import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const formSubmitEmbedEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-software-form-submit-embed-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
